import { createButton } from '@archer-technologies/ui-components';
import { createElement } from 'react';
import { Plugin, Template, TemplatePlaceholder } from '@devexpress/dx-react-core';
var pluginDependencies = [{
  name: 'Toolbar'
}];

var ToolbarDelete = function ToolbarDelete(_ref) {
  var onClick = _ref.onClick,
      disabled = _ref.disabled,
      translate = _ref.translate;
  return /*#__PURE__*/createElement(Plugin, {
    name: "toolbarDeleteFilter",
    dependencies: pluginDependencies
  }, /*#__PURE__*/createElement(Template, {
    name: "toolbarContent"
  }, /*#__PURE__*/createElement(TemplatePlaceholder, null), createButton({
    type: 'DELETE',
    isIconButton: true,
    tooltipTitle: translate('rgrd:deleteButton'),
    actionType: 'primary',
    onClick: onClick,
    disabled: disabled,
    translate: translate
  })));
};

export { ToolbarDelete };